import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { Router } from '@angular/router';
import { NbToastrService, NbDialogService, NbDialogRef } from '@nebular/theme';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';
import { Settings } from '../../../shared/data/settings';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'ngx-setting-general',
  templateUrl: './setting-general.component.html',
  styleUrls: ['./setting-general.component.scss']
})
export class SettingGeneralComponent implements OnInit {


  description;
  map;
  telephon;
  adress;
  emaile;
  titre;
  slogan;
  hideLoader = true;
  hideButon;
  imageChoisie;
  logo;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  @ViewChild('userRegistrationForm',{static:true}) myForm; 
  // logo = {path: "", baseUrl: "",hash:"",mime:"",name:"",phash:"",size:7,tmb:"",ts:8,url:""};

  categories = [];
  

  param = new Settings;

  constructor(protected dialogRef: NbDialogRef<SettingGeneralComponent>,private dialogService: NbDialogService, private router:Router,public toastr:NbToastrService,private apiService: ApiService,private sanitizer: DomSanitizer,private sendeurService:EventSendeurService) { }

  ngOnInit() {


    this.getParameterPage();

    this.getCategories();

    this.sendeurService.fichier.asObservable().subscribe(data =>{
      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);
    },(err)=>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }
  
      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })


  }


  getCategories(){

    this.apiService.getAllCategoryProvider('article').subscribe(data =>{
     
      data.sort(this.compare);
      
      this.categories = data;
      // this.source.load( plainToClass( Categorie, data) );
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })

  }

  compare(a,b) {

     if(a.chemin < b.chemin)
     return -1;

     if(a.chemin > b.chemin)
     return 1;

     return 0;
    
  }

  addFile(){
    this.dialogService.open(MediathequeComponent);
  }

  close(){
    this.dialogRef.close();
  }

  getParameterPage(){
    this.apiService.getParametresGeneralProvider().subscribe((data:any) =>{
      if(data !== null)
      this.param = plainToClass(Settings, data);
    })
  }

  addParameter(){
    this.hideLoader = false;
    this.hideButon = true;
    var data = JSON.parse(localStorage.getItem("fichier"));
    
    if(localStorage.getItem("fichier")){
      this.logo = 'https://apismid.cotafric.net'+data.url;
    }
    
     console.log( this.logo);
    this.apiService.updateParametresGeneralProvider(this.param).subscribe(data =>{
      this.toastr.success("mise à jour réussie","success");
      this.imageChoisie = '';
      this.sendeurService.fichier.next(null);
      localStorage.removeItem("fichier");
      // this.myForm.resetForm();
      // this.sendeurService.sendArticleEvent(4);
      this.hideLoader = true;
      this.hideButon = false;
     
    },(err)=>{
      console.log(err);
      this.toastr.danger("echec de modification, vérifiez que tous les champs sont bien remplis");
      this.hideLoader = true;
      this.hideButon = false;
      this.toastr.danger("Echec de mise à jour","erreur");
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

    })
  }

}
